import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { ReinosMaps } from './core'
import './maps'

window.REINOS_MAPS = new ReinosMaps
